module.exports = __webpack_public_path__ + "static/media/YF32_7.908da1ba.jpg";